module.exports = __webpack_public_path__ + "img/adv_bg.cb138acb.png";